module.exports = __webpack_public_path__ + "media/images/front/icon_dba_300-ae0d1cbcb469efe03c4d956f8c8d3215.jpg";